import React from 'react';
import TableRoutes from './TableRoutes';
import { Card } from 'react-bootstrap';
/* import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutateRouter from './MutateRouter';
import Input from 'components/common/Input'; */
import useRoutes from 'hooks/useRoutes';

const Routes = () => {
 const { categories } = useRoutes();
 return (
  <Card>
   <Card.Body className="px-0 px-sm-3 pt-0 pt-md-3">
    <TableRoutes data={categories} setData={() => console.log} product={{}} setProduct={() => console.log} />
   </Card.Body>
  </Card>
 );
};

export default Routes;
